module.exports = __webpack_public_path__ + "officialStatic/img/smj.267e736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/smj.png
// module id = fxj2
// module chunks = 0